import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { saveToken } from '../api';
import { ScanText, MailCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');
    const verified = params.get('verified') === '1';

    if (token) {
      saveToken(token);
      if (verified) {
        toast.success('Email verified!', { description: 'Your account is now active.' });
      }
      setTimeout(() => navigate('/dashboard', { replace: true }), 700);
    } else if (error === 'verify_expired') {
      setErrorMsg('Verification link has expired. Please register again or request a new link.');
      setHasError(true);
      setTimeout(() => navigate('/', { replace: true }), 4000);
    } else if (error === 'invalid_token') {
      setErrorMsg('Invalid or already-used verification link.');
      setHasError(true);
      setTimeout(() => navigate('/', { replace: true }), 4000);
    } else {
      setHasError(true);
      setErrorMsg(error || 'Authentication failed.');
      setTimeout(() => navigate('/?auth_error=' + (error || 'unknown'), { replace: true }), 1500);
    }
  }, [navigate, params]);

  const verified = params.get('verified') === '1';

  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-background gap-4'>
      <div className='w-10 h-10 rounded-xl bg-primary flex items-center justify-center'>
        {verified ? <MailCheck className='w-5 h-5 text-primary-foreground' /> : <ScanText className='w-5 h-5 text-primary-foreground' />}
      </div>

      {hasError ? (
        <>
          <p className='text-foreground font-semibold'>Authentication failed</p>
          <p className='text-sm text-muted-foreground text-center max-w-xs'>{errorMsg}</p>
          <p className='text-xs text-muted-foreground'>Redirecting you back…</p>
        </>
      ) : verified ? (
        <>
          <p className='text-foreground font-semibold'>Email verified!</p>
          <p className='text-sm text-muted-foreground'>Your account is active. Loading dashboard…</p>
          <div className='w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin' />
        </>
      ) : (
        <>
          <p className='text-foreground font-semibold'>Signing you in…</p>
          <div className='w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin' />
        </>
      )}
    </div>
  );
}
